import types from "@/data/types"
import tableSort from "@/data/view/tableSort"
import ticketHeaders from "@/data/view/ticketHeaders"
import csvColumnOrder from "@/data/view/csvColumnOrder"
import {fieldSorter} from "@/base_lib/helper/utils"

const prepareCSVItems = (type, items) => {
    let sortFields = tableSort(type)
    const columnOrder = csvColumnOrder(type)

    switch (type) {
        case types.OSS_API:
            return items.map(item => ({
                team: item.team,
                account: item.account_user,
                event_id: item.event_id,
                event: item.event,
                alternative: item.alternative,
                year: item._item?.event_detail?.__event_date_year === '2999' ? 'TBD' : item._item?.event_detail?.__event_date_year,
                date: item._item.event_detail.__event_date_us_format,
                time: item._item.event_detail.__event_time_us_format,
                venue: item.venue,
                section: item.section,
                row: item.row,
                seat: item.seat,
                qr: item.barcode,
                additional: item.additional,
            }))
        case types.SG:
            return items.map(item => ({
                account_user: item.account_token,
                date: new Date(item.event_datetime_local).toLocaleDateString('en-US', { weekday: 'short', month: 'numeric', day: 'numeric' }),
                time: new Date(item.event_datetime_local).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true }),
                section: item.section,
                row: item.row,
                seat: item.seat,
                event_id: item.event_id,
                event: item.event_name,
                year: new Date(item.event_datetime_local).getFullYear().toString(),
                venue: item.venue_name,
                barcode: item.token,
            }))
        case types.BALLPARK_APP:
            return items.map(bItem => ({
                ...bItem,
                barcode_ext: (bItem.barcode.startsWith("[")) ? "" : bItem.barcode + ":1T:" + bItem.ticket_id?.split("@")[0],
            })).map( ({ _search, _item, id, designated_id, timestamp, ...restOfItems}) => restOfItems)
            .sort(fieldSorter((sortFields)))
        case types.PACIOLAN_SCRAPE:
            console.warn("Please implement prepareCSVItems for Paciolan Scrape v2", items)
            return items.map(item => ({
                team: item.team,
                account: item.account_user,
                event_id: item.event_id,
                event: item.event,
            }))
        case types.SEATGEEK_SCRAPE:
            return items.map(item => ({
                account: item.account_user,
                ticket_sid: item.ticket_sid,
                event: item.event,
                date: item.date,
                time: item.time,
                venue: item.venue,
                section: item.section,
                row: item.row,
                seat: item.seat,
                barcode: item.barcode
            }))
        case types.TM_AM_SCRAPE:
            if (!columnOrder || columnOrder.length === 0) {
                return items.map(({ _search, _item, id, ...rest }) => rest)
            }
            return items.map(item => {
                const row = {
                    team: item.team,
                    account: item.account,
                    event_id: item.eventid,
                    event: item.eventtitle,
                    alternative: item.eventtitlealt,
                    year: item.year,
                    date: item.date,
                    time: item.time,
                    venue: item.venue,
                    section: item.section,
                    row: item.row,
                    seat: item.seat,
                    qr: item.barcode,
                    additional: item.additional
                }
                const ordered = {}
                columnOrder.forEach(key => {
                    if (row.hasOwnProperty(key)) ordered[key] = row[key]
                })
                return ordered
            })
        default:
            return items.map( ({ _search, _item, id, designated_id, timestamp, ...restOfItems}) => restOfItems)
    }
}

export default prepareCSVItems